angular.module('CarsSaraBo').factory('LegalDocumentService', ['$resource', function ($resource) {
    return $resource('../rest/company/:companyOid/contract/:contractOid/legalDocument/:legalDocumentOid',
        {
            companyOid: '@companyOid',
            contractOid: '@contractOid',
            legalDocumentOid: '@legalDocumentOid'
        },
        {
            update: {method: 'PUT'},
            get: {method: 'GET'},
            getAll: {method: 'GET', isArray: true},
            remove: {method: 'DELETE'}
        }
    )
}
]);

angular.module('CarsSaraBo').factory('LegalDocumentResourceService', ['$resource', function ($resource) {
    return $resource('../rest/company/:companyOid/contract/:contractOid/legalDocument/:legalDocumentOid/resource',
        {
            companyOid: '@companyOid',
            contractOid: '@contractOid',
            legalDocumentOid: '@legalDocumentOid'
        },
        {
            get: {method: 'GET'}
        }
    )
}
]);



//////////////////
// WEBPACK FOOTER
// ./public/app/contract/legal_document_service.js
// module id = 923
// module chunks = 3